import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { headersConfig } from "./apiHelpers";

export const baseApi = createApi({
	reducerPath: "baseApi",
	tagTypes: [
		"offersTag",
		"featureTrackerTag",
		"segmentationTag",
		"experimentsTag",
		"bouncyChestTag",
		"FreeGiftTag",
		"PWARewardTag",
		"PWARewardStatusTag",
		"poisBountyTag",
		"friendShopGiftsTag",
		"friendShopFriendsTag",
		"friendInviteFriendsTag",
		"userSegmentsTag",
		"hudTag"
	],
	keepUnusedDataFor: 1800,
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	//refetchOnFocus: true,
	baseQuery: fetchBaseQuery({
		baseUrl: process.env.REACT_APP_BACKEND_URI,
		prepareHeaders: (headers, { getState }) => {
			return headersConfig(headers, getState);
		}
	}),
	endpoints: () => ({})
});
